import {
  QuestionGroupSortAttribute,
  QuestionGroupSortInput,
  SortDirection
} from '@generated/base-types';
import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import { QuestionGroup } from '@new/pools/lib/types/question-group';

export interface QuestionGroupsStateModel {
  items: EntityData<QuestionGroup[]>;
  selectedIds: string[];
  sortAttributes: QuestionGroupSortInput[];
}

export const questionGroupsStateDefaults: QuestionGroupsStateModel = {
  items: initialEntityData(),
  selectedIds: [],
  sortAttributes: [
    {
      attribute: QuestionGroupSortAttribute.SequentialNumber,
      direction: SortDirection.Asc
    }
  ]
};
